import Client from 'config/axios';
import posthog from 'posthog-js';
import { ReportPeriodValue } from 'components/inputs/PeriodSelector/PeriodSelector';

export const getReport = async (
  token: string,
  id: string,
  reportType: string,
  sendEmail: any,
  month?: string,
  year?: string,
  startMonth?: string,
  endMonth?: string,
  period?: ReportPeriodValue
) => {
  let params;
  let reportName: null | string = null;
  // Solo se mandan fechas si hay un período; sin ellas el reporte es histórico.
  const periodParams =
    period?.startDate && period?.finishDate
      ? { startDate: period.startDate, finishDate: period.finishDate }
      : {};
  switch (reportType) {
    case 'PREVIEW_EMPLOYEE':
      reportName = 'Reporte_De_Ganador_Del_Mes';
      params = {
        reportType: reportType,
        sendEmail: sendEmail
      };
      break;
    case 'CHALLENGE':
      reportName = 'Reporte_De_Challenge';
      params = {
        reportType: reportType,
        sendEmail: sendEmail,
        challengeId: id
      };
      break;
    case 'CAMPAIGN':
      reportName = 'Reporte_De_Campaña';
      params = {
        reportType: reportType,
        campaignId: id
      };
      break;
    case 'PARTICIPATIONS_BY_CAMPAIGN':
      reportName = 'Reporte_De_Participación_De_Campaña';
      params = {
        reportType: reportType,
        campaignId: id
      };
      break;
    case 'PARTICIPATIONS_BY_DATE':
      reportName = 'Reporte_De_Participaciones';
      params = {
        reportType: reportType,
        month: month,
        year: year
      };
      break;
    case 'MONTHLY_AMBASSADORS':
      reportName = 'Reporte_Mensual_De_Embajadores';
      params = {
        reportType: reportType,
        month: month,
        year: year
      };
      break;
    case 'CONSOLIDATED':
      reportName = 'Reporte_De_Consolidado';
      params = {
        reportType: reportType,
        download: false,
        startMonth: startMonth,
        endMonth: endMonth,
        year: year
      };
      break;
    case 'AMBASSADORS':
      reportName = 'Reporte_De_Embajadores';
      params = {
        reportType: reportType,
        ...periodParams
      };
      break;

    case 'PLATFORM':
      reportName = 'Reporte_De_Campañas';
      params = {
        reportType: reportType,
        ...periodParams
      };
      break;

    case 'CREATOR':
      reportName = 'Reporte_De_Challenges';
      params = {
        reportType: reportType,
        ...periodParams
      };
      break;

    case 'BONUS':
      reportName = 'Reporte_De_Contenidos';
      params = {
        reportType: reportType,
        ...periodParams
      };
      break;

    default:
      reportName = `Reporte_${reportType}`;
      params = {
        reportType: reportType
      };
      break;
  }

  const { data } = await Client.get(`report`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  posthog.capture('CreateReport', {
    CreateReport: data,
    Params: { ...params, ...{ reportName }, periodType: period?.type ?? null }
  });

  posthog.capture(reportName, {
    CreateReport: data,
    Params: params
  });
  return {
    data
  };
};
